// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Aggregated execution results across all test plans in the release, using the latest run (regression) of each test plan.
 * @export
 * @interface ReleaseReadinessSummary
 */
export interface ReleaseReadinessSummary {
  [key: string]: number | any;
  /**
   * Total number of test case executions across all plans
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  total: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  passed: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  failed: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  blocked: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  skipped: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  unexecuted: number;
  /**
   * Percentage of passed out of total (excluding unexecuted)
   * @type {number}
   * @memberof ReleaseReadinessSummary
   */
  passRate: number;
}

export function ReleaseReadinessSummaryFromJSON(
  json: any
): ReleaseReadinessSummary {
  // Standard known keys from the API response (snake_case)
  const knownKeys = [
    "total",
    "passed",
    "failed",
    "blocked",
    "skipped",
    "unexecuted",
    "pass_rate",
  ];
  let result: any = {
    total: json["total"],
    passed: json["passed"],
    failed: json["failed"],
    blocked: json["blocked"],
    skipped: json["skipped"],
    unexecuted: json["unexecuted"],
    passRate: json["pass_rate"],
  };
  // Copy over any additional (custom status) keys
  const otherKeys = Object.keys(json).filter(
    (key) => knownKeys.indexOf(key) === -1
  );
  if (otherKeys.length > 0) {
    otherKeys.forEach((key) => {
      result[key] = json[key];
    });
  }
  return result;
}

export function ReleaseReadinessSummaryToJSON(
  value?: ReleaseReadinessSummary
): any {
  if (value === undefined) {
    return undefined;
  }
  const knownKeys = [
    "total",
    "passed",
    "failed",
    "blocked",
    "skipped",
    "unexecuted",
    "passRate",
  ];
  let result: any = {
    total: value.total,
    passed: value.passed,
    failed: value.failed,
    blocked: value.blocked,
    skipped: value.skipped,
    unexecuted: value.unexecuted,
    pass_rate: value.passRate,
  };
  const otherKeys = Object.keys(value).filter(
    (key) => knownKeys.indexOf(key) === -1
  );
  if (otherKeys.length > 0) {
    otherKeys.forEach((key) => {
      result[key] = value[key];
    });
  }
  return result;
}
